import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Form, withFormik} from "formik";

import Divider from "../../utilities/Divider/Divider";
import ReactTable from "../conteiners/ReactTable";
import {DateInput, Select} from "../Inputs";
import TabsContainer from "../NEW-tabs/TabsContainer";
import FilterButton from "../SamplesList/SampleParts/FilterButton";

import "../SamplesList/samples.scss";

const ReportComponent = ({resetForm, submitForm}) => {
  const {t} = useTranslation();
  const [areFiltersDefined, setFiltersDefined] = useState(false);

  const tableColumns = React.useMemo(
    () => [
      {
        header: t("No Data"),
        accessorKey: "empty",
        cell: () => "",
      },
    ],
    [t],
  );

  const officesOptions = [
    {title: "NOK", value: 1},
    {title: "KBP", value: 2},
  ];
  const brandManagerOptions = [
    {title: "Manager A", value: 1},
    {title: "Manager B", value: 2},
  ];
  const pzManagerOptions = [
    {title: "PZ A", value: 1},
    {title: "PM B", value: 2},
  ];
  const periodYearOptions = [
    {title: "2024", value: 2024},
    {title: "2025", value: 2025},
    {title: "2026", value: 2026},
  ];
  const factoriesOptions = [
    {title: "Rimadesio", value: 1},
    {title: "Poliform", value: 2},
  ];
  const sampleGroupOptions = [
    {title: t("Group") + " 1", value: 1},
    {title: t("Group") + " 2", value: 2},
  ];
  const statusOptions = [
    {title: t("On Stock"), value: 1},
    {title: t("Under Report"), value: 2},
  ];
  const periodOptions = [
    {title: t("I quarter"), value: 1},
    {title: t("II quarter"), value: 2},
    {title: t("III quarter"), value: 3},
    {title: t("IV quarter"), value: 4},
  ];

  return (
    <TabsContainer label={"sample report"} closableTabs={true}>
      <Form style={{width: "100%"}}>
        <div className="fc jcfs autolabel nowrap" style={{gap: "1em", alignItems: "flex-start", width: "100%"}}>
          <div className="flex_container aist gap5" style={{flexDirection: "column"}}>
            <FilterButton
              onFilter={() => {
                setFiltersDefined(true);
                submitForm();
              }}
              delFilter={() => {
                resetForm();
                setFiltersDefined(false);
              }}
              questionTitle={t("Filter")}
              areFiltersDefined={areFiltersDefined}
            />
          </div>
          <div className="samp_filter_block">
            <div className="samp_filter_block_left">
              <Select
                label={t("OfficeSolo")}
                name="officeId"
                options={officesOptions}
                multi={true}
                width="5rem"
                generalClassName="samp_filter_item"
                minFilterLength={1}
              />
              <Select
                label={t("Brand Manager")}
                name="brandManagerId"
                options={brandManagerOptions}
                multi={true}
                width="10rem"
                generalClassName="samp_filter_item"
                minFilterLength={1}
              />
              <Select
                label={t("Manager p/z")}
                name="pzManagerId"
                options={pzManagerOptions}
                multi={true}
                width="10rem"
                generalClassName="samp_filter_item"
                minFilterLength={1}
              />
              <Select
                label={t("Period, Year")}
                name="periodYear"
                options={periodYearOptions}
                width="6rem"
                generalClassName="samp_filter_item"
              />
              <div className="samp_filter_item">
                <span>{t("or select the period")}</span>
              </div>
              <Select
                label={t("Factory")}
                name="factoryId"
                options={factoriesOptions}
                multi={true}
                width="10rem"
                generalClassName="samp_filter_item"
                minFilterLength={1}
              />
              <Select
                label={t("Sample Group")}
                name="sampleGroupId"
                options={sampleGroupOptions}
                multi={true}
                width="10rem"
                generalClassName="samp_filter_item"
                minFilterLength={1}
              />
              <Select
                label={t("StatusFull")}
                name="statusId"
                options={statusOptions}
                multi={true}
                width="10rem"
                generalClassName="samp_filter_item"
              />
              <Select
                label={t("Period")}
                name="periodId"
                options={periodOptions}
                width="10rem"
                generalClassName="samp_filter_item"
              />
            </div>

            <div className="period_nom_wrapper">
              <div className="period_nom">{t("Period")}</div>
              <div className="request-date-wrapper">
                <DateInput label={t("From")} name="dateFrom" />
                <DateInput label={t("To")} name="dateTo" />
              </div>
            </div>
          </div>
        </div>

        <Divider />
        <div
          className="fGrow fShrink fcCol overflowAuto"
          style={{
            position: "relative",
            height: "75vh",
          }}
        >
          <ReactTable defaultData={[]} columns={tableColumns} selectable={false} showEmptyStateIcon={true} />
        </div>
      </Form>
    </TabsContainer>
  );
};

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: () => ({
    officeId: "",
    brandManagerId: "",
    pzManagerId: "",
    periodYear: "",
    factoryId: "",
    sampleGroupId: "",
    statusId: "",
    periodId: "",
    dateFrom: "",
    dateTo: "",
  }),
  handleSubmit: () => {},
})(ReportComponent);
